import { Injectable } from '@angular/core';
import { HttpClient2 } from './http-client.service';

//Clases
import { FormaPago } from '../models';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ImportarFormaPagoDTO } from '../dto';
import { IResultado } from '../index';
import { HttpHeaders } from '@angular/common/http';
import { Cookies } from '../commons';

@Injectable()
export class FormaPagoService {
  ciaId : string;
  constructor(private http : HttpClient2) {
    let currentUser  = JSON.parse(localStorage.getItem("currentUser"));
    this.ciaId = "/"+currentUser.compania.companiaId;
  }

  listar() : Observable<Array<FormaPago>>{
    return this.http.listar(this.ciaId+"/formas-pago").map(
      (data: IResultado) => {
        let list = Array<FormaPago>();
        let obj;
        if(data){
          for (const d of data.resultado) {
            obj = new FormaPago();
            obj.copiar(d);
            list.push(obj);
          }
        }
        return list;
    });
  }
  consultar(data) : Observable<Array<FormaPago>>{
    return this.http.consultar(this.ciaId+"/formas-pago/consultar",data).map(
      (data: IResultado) => {
        let list = Array<FormaPago>();
        let obj;
        if(data){
          for (const d of data.resultado) {
            obj = new FormaPago();
            obj.copiar(d);
            list.push(obj);
          }
        }
        return list;
    });
  }

  obtener(id : number) : Observable<FormaPago>{
    return this.http.obtener(this.ciaId+"/formas-pago/"+id).map(
      (data: IResultado) => {
        let obj = new FormaPago();
        if(data){
          obj.copiar(data.resultado);
        }
        return obj;
    });
  }

  registrar(formaPago : FormaPago, funcionalidad?: String){
    return this.http.registrar(this.ciaId+"/formas-pago", formaPago, { funcionalidad });
  }

  modificar(formaPago : FormaPago, funcionalidad?: String){
    return this.http.modificar(this.ciaId+"/formas-pago", formaPago, { funcionalidad });
  }

  eliminar(formaPagoId : number, funcionalidad?: String){
    return this.http.eliminar(this.ciaId+"/formas-pago/"+formaPagoId, { funcionalidad });
  }

  registrarImportacion(formaPago: Array<ImportarFormaPagoDTO>, companiaId?: string, funcionalidad?: String) {
    if (companiaId == undefined) companiaId = this.ciaId;
    return this.http.registrar(companiaId + "/formas-pago/registrar-importacion", formaPago, { funcionalidad });
  }

  obtenerHeaders(httpOptions? : Object) : HttpHeaders{
    return this.http.obtenerHeaders();
  }
  obtenerExcelExportacionReportes(data: any, tipoReporte: string): Observable<any> {
    return this.http.consultar("/reportes/" + tipoReporte + "/exportar-excel", data, { responseType: "text" });
  }


}
